import { render, staticRenderFns } from "./RVBChargingpointsByPID.vue?vue&type=template&id=5552c592"
import script from "./RVBChargingpointsByPID.vue?vue&type=script&lang=js"
export * from "./RVBChargingpointsByPID.vue?vue&type=script&lang=js"
import style0 from "./RVBChargingpointsByPID.vue?vue&type=style&index=0&id=5552c592&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports